<template>
    <div v-if="isNotLogin">
        <title-screen title="14"></title-screen>
        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane name="edit">
                <span slot="label"><i class="el-icon-info"></i>会員情報変更</span>
                <member-edit></member-edit>
            </el-tab-pane>
<!--            <el-tab-pane>-->
<!--                <span slot="label"><i class="el-icon-s-data"></i>My家族年表変更</span>-->
<!--                <edit-chronology :hide-title="true"></edit-chronology>-->
<!--            </el-tab-pane>-->
            <el-tab-pane name="password">
                <span slot="label"><i class="el-icon-s-release"></i>パスワード変更</span>
                <member-change-password></member-change-password>
            </el-tab-pane>
            <el-tab-pane name="loginId">
                <span slot="label"><i class="el-icon-user"></i>ログインID変更</span>
                <member-change-login-id></member-change-login-id>
            </el-tab-pane>
            <el-tab-pane name="withdraw">
                <span slot="label"><i class="el-icon-s-release"></i>退会</span>
                <member-withdraw></member-withdraw>
            </el-tab-pane>
        </el-tabs>
    </div>
    <div v-else></div>
</template>

<script>
import TitleScreen from '@/components/common/TitleScreen'
// import EditChronology from '../9_life_event/EditChronology'
import MemberWithdraw from './MemberWithdraw'
import MemberEdit from './MemberEdit'
import MemberChangePassword from './MemberChangePassword'
import MemberChangeLoginId from './MemberChangeLoginId'
import { SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
import { mapGetters } from 'vuex'
export default {
    name: 'MemberInfo',
    data () {
        return {
            isNotLogin: false,
            activeTab: 'edit'
        }
    },
    components: {
        MemberEdit,
        MemberChangePassword,
        MemberChangeLoginId,
        MemberWithdraw,
        // EditChronology,
        TitleScreen
    },
    computed: {
        ...mapGetters(['currentUser', 'isAuthenticated'])
    },
    methods: {
        fetchData () {
            let memberId = this.currentUser.id === undefined ? '' : this.currentUser.id
            if (parseInt(memberId) > 0) {
                this.isNotLogin = true
            } else {
                this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
            }
        },
        syncTabFromRoute () {
            if (this.$route.query.tab === 'loginId') {
                this.activeTab = 'loginId'
            }
        }
    },
    watch: {
        '$route.query.tab' () {
            this.syncTabFromRoute()
        }
    },
    created () {
        this.syncTabFromRoute()
        this.fetchData()
        this.$bus.$on('refreshData', (data) => {
            if (this.$route.name === data) {
                this.fetchData()
            }
        })
        localStorage.removeItem('memberInfo')
    }
}
</script>
<style scoped>
    @import "../../../../assets/css/custom.css";
</style>
